'use strict';

module.exports = function isObject(x) {
	return !!x && (typeof x === 'function' || typeof x === 'object');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/helpers/isObject.js
// module id = 17
// module chunks = 0